import { useEffect, useState } from 'react';
import { REACT_APP_API_URL } from 'helpers/conf';

import { configPayments } from 'helpers/payments';

export const usePaymentLanguage = (language: string) => {
  useEffect(() => {
    configPayments(language);
  }, [language]);
};

let isPaymentLibConfigured = false;

export const configPaymentsLib = () => {
  window.PaymentsAPI?.config({
    language: 'en',
    serverUrl: REACT_APP_API_URL,
    cdnList: ['https://cdn.softswiss.net', 'https://cdn2.softswiss.net'],
  }).then(() => {
    console.log('usePaymentsAPIReady:configPaymentsLib');
    if (window.PaymentsAPI) {
      isPaymentLibConfigured = true;
    }
  });
};

export const usePaymentsAPIReady = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Poll until PaymentsAPI exists
    const interval = setInterval(() => {
      if (window.PaymentsAPI && isPaymentLibConfigured) {
        setIsReady(true);
        clearInterval(interval);
      }
    }, 100); // check every 100ms

    return () => clearInterval(interval);
  }, []);

  return isReady;
};
